import Route from '@ember/routing/route';
import { service } from '@ember/service';
import ContactsCache from 'donor-elf-web/services/contacts-cache';
import NavbarSettingsService from 'donor-elf-web/services/navbar-settings';

export interface GroupRouteModel {
  group: string; // group name
}

export default class GroupRoute extends Route {
  @service declare contactsCache: ContactsCache;
  @service declare navbarSettings: NavbarSettingsService;

  model(params: any): GroupRouteModel {
    this.navbarSettings.title = `${params.groupName} Group`;
    return {
      group: params.groupName,
    };
  }
}
